import { MemberSection } from '~/components/member/layout'
import { MemberSectionGuard } from './MemberGuard'
import { SignInSettings } from './SignInSettings'

/** `/me/sign-in`: the "Sign-in" section (passwordless spec §4): the optional password and the sign-out. */
export default function SignIn() {
  return (
    <MemberSectionGuard>
      {({ member }) => (
        // No frame on a phone (a box inside the page costs 28 px of a phone's width), as on Write to us.
        <MemberSection frameFrom='md' maxW='xl'>
          <SignInSettings email={member.email} />
        </MemberSection>
      )}
    </MemberSectionGuard>
  )
}
